// client/src/api/ApiCourts.js
import flex from './FlexFetch'

const endpoint = '/api/1.0/courts/'

function unwrapStrictData(payload) {
  return payload && Object.prototype.hasOwnProperty.call(payload, 'data')
    ? payload.data
    : payload
}

// List/search courts
async function search({
  query,
  city,
  state,
  zip,
  verification_status,
  limit,
} = {}) {
  const params = new URLSearchParams()
  if (query) params.set('query', query)
  if (city) params.set('city', city)
  if (state) params.set('state', state)
  if (zip) params.set('zip', zip)
  if (verification_status)
    params.set('verification_status', verification_status)
  if (limit) params.set('limit', limit)
  const url =
    endpoint + 'all' + (params.toString() ? `?${params.toString()}` : '')
  const res = await flex.flexFetch(url)
  const payload = await flex.handleResponse(res)
  const d = Array.isArray(payload) ? payload : unwrapStrictData(payload)
  return Array.isArray(d) ? d : (d?.items ?? [])
}

// Create a new court
async function create(court) {
  const res = await flex.flexFetch(endpoint + 'post', {
    method: 'POST',
    body: JSON.stringify(court),
  })
  return unwrapStrictData(await flex.handleResponse(res))
}

// Verify or change verification status (admin only)
async function verify({ id, verification_status, verification_metadata }) {
  const res = await flex.flexFetch(endpoint + 'verify', {
    method: 'POST',
    body: JSON.stringify({ id, verification_status, verification_metadata }),
  })
  return unwrapStrictData(await flex.handleResponse(res))
}

// Update court (admin, owner, or creator)
async function update(court) {
  const res = await flex.flexFetch(endpoint + 'update', {
    method: 'POST',
    body: JSON.stringify(court),
  })
  return unwrapStrictData(await flex.handleResponse(res))
}

// Delete court (admin only)
async function deleteCourt(id) {
  const res = await flex.flexFetch(endpoint + 'delete', {
    method: 'POST',
    body: JSON.stringify({ id }),
  })
  return unwrapStrictData(await flex.handleResponse(res))
}

const ApiCourts = {
  search,
  create,
  verify,
  update,
  delete: deleteCourt,
}

export default ApiCourts
